// extracted by mini-css-extract-plugin
module.exports = {"text-center":"Invalid_text-center__1Ne0m"};